import React from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'

export const tabs = [{
  path: '/discovery',
  name: 'Categories'
}, {
  path: '/discovery/filter',
  name: 'Advanced Search'
}]

export default function DiscoveryNav({ active }) {
  return (
    <ul className="nav nav-pills">
      {tabs.map((tab, index) => {
        const isActive = active === tab.path
        const linkStyle = isActive ? {
          backgroundColor: '#ECFF19',
          color: '#0B0D0F'
        } : {
          backgroundColor: '#1a1d24',
          color: '#ECFF19'
        }

        return (
          <li key={index} className="nav-item pe-2 fw-500">
            <Link to={tab.path} className="nav-link rounded-4 px-4 fw-500" style={linkStyle}>
              {tab.name}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
